<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card card-custom gutter-b">
          <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">Manage Notifications</h3>
            </div>
          </div>
          <div class="card-body">
            <!--begin::Form-->
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                v-model="title"
                :rules="titleRules"
                label="Title"
                required
              ></v-text-field>

              <v-textarea
                v-model="notification"
                :rules="[(v) => !!v || 'Notification is required']"
                label="Notification"
                required
              ></v-textarea>

              <v-file-input
                accept="image/*"
                label="Featured Image"
                prepend-icon=""
                @change="uploadImage"
                @click:clear="clearImage"
                type="file"
                show-size
              ></v-file-input>
              <v-progress-linear
                v-show="progressValue > 0"
                v-model="progressValue"
                :buffer-value="bufferValue"
              ></v-progress-linear>

              <v-btn
                :disabled="!valid || loading"
                color="success"
                class="mr-4"
                @click="validate"
              >
                {{ "Save" }}
              </v-btn>

              <!-- <v-btn color="error" class="mr-4" @click="reset"> Clear </v-btn> -->
            </v-form>
            <!--end::Form-->
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card card-custom gutter-b">
          <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">All Notifications</h3>
            </div>
          </div>
          <div class="card-body">
            <!--begin::Table-->

            <v-card-title>
              <div class="row search-bar">
                <div class="col-md-4">
                  <v-text-field
                    v-model="search"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </div>
              </div>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="allNotifications"
              :search="search"
            >
              <template v-slot:[`item.img`]="{ item }">
                <v-icon
                  v-if="item.img != ''"
                  small
                  class="mr-2"
                  @click="openImage(item.img)"
                  >mdi-image-search</v-icon
                >
              </template>
            </v-data-table>

            <!--end::Table-->
          </div>
        </div>
      </div>
    </div>
    <v-row justify="center">
      <v-dialog v-model="modalDialog" max-width="400">
        <v-card>
          <v-img :src="modalImage"> </v-img>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="modalDialog = false">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<style lang="scss" scoped>
.v-progress-linear {
  margin-bottom: 5px;
}
.search-bar {
  justify-content: flex-end;
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { db, storage } from "../../../firebase";
import { collection, query, getDocs, addDoc } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
export default {
  data: () => ({
    valid: true,
    title: "",
    titleRules: [(v) => !!v || "Title is required"],
    imageUrl: "",
    notification: "",
    search: "",
    headers: [
      {
        text: "Title",
        align: "left",
        value: "title",
      },
      { text: "Image", value: "img" },
      { text: "Notification", value: "description" },
    ],
    allNotifications: [],
    cancelUpload: false,
    imagePath: "",
    progressValue: 0,
    modalImage: "",
    modalDialog: false,
    loading: false,
  }),
  components: {},

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Notifications", route: "manage-notifications" },
      // { title: "Manage Notifications" },
    ]);
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.saveNotification();
      }
    },
    reset() {
      this.$refs.form.reset();
      this.progressValue = 0;
    },
    uploadImage(e) {
      if (e) {
        this.cancelUpload = false;
        let file = e;
        this.valid = false;
        this.imagePath = "notifications/" + Math.random() + "_" + file.name;
        // var storageRef = storage.ref(this.imagePath);
        var storageRef = ref(storage, this.imagePath);
        // var uploadTask = storageRef.put(file);
        var uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on(
          "state_changed",
          (snapshot) => {
            this.progressValue =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

            if (this.cancelUpload) {
              //Upload is not complete yet, let's cancel
              uploadTask.cancel();
              this.valid = true;
              this.progressValue = 0;
            }
          },
          () => {
            // Handle unsuccessful uploads
            // console.log(error);
          },
          () => {
            // Handle successful uploads on complete
            // For instance, get the download URL: https://firebasestorage.googleapis.com/...
            // uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            //   this.imageUrl = downloadURL;
            //   this.valid = true;
            //   // console.log('File available at', downloadURL);
            // });

            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
              this.imageUrl = downloadURL;
              this.valid = true;
              console.log("File available at", downloadURL);
            });
          }
        );
      }
    },
    clearImage() {
      if (this.valid) {
        let image = storage.refFromURL(this.imageUrl);
        image
          .delete()
          .then(() => {
            this.imageUrl = "";
            this.imagePath = "";
          })
          .catch(function () {
            // Uh-oh, an error occurred!
            // console.log('an error occurred', error);
          });
      } else {
        this.cancelUpload = true;
        this.progressValue = 0;
      }
    },
    async saveNotification() {
      // if (this.$refs.form.validate()) {
      this.loading = true;

      const docRef = await addDoc(collection(db, "notifications"), {
        title: this.title,
        description: this.notification,
        timestamp: new Date(),
        img: this.imageUrl,
        imagepath: this.imagePath,
        seen: [],
      });
      // console.log("Document written with ID: ", docRef.id);
      this.reset();
      this.getNotifications();
      this.loading = false;

      // db.collection("notifications")
      //   .add({
      //     title: this.title,
      //     description: this.notification,
      //     timestamp: new Date(),
      //     img: this.imageUrl,
      //     imagepath: this.imagePath,
      //   })
      //   .then(() => {
      //     this.reset();
      //     this.loading = false;
      //   })
      //   .catch(() => {
      //     // console.error('Error adding document: ', error);
      //   });
      // }
    },

    async getNotifications() {
      // rdb.collection("notifications").onSnapshot((snapshot) => {
      //   let requests = [];

      //   snapshot.forEach((doc) => {
      //     requests.push({ ...doc.data(), id: doc.id });
      //   });
      //   this.allNotifications = requests;
      // });

      const q = query(collection(db, "notifications"));

      const querySnapshot = await getDocs(q);
      let requests = [];
      querySnapshot.forEach((doc) => {
        requests.push({ ...doc.data(), id: doc.id });
      });
      this.allNotifications = requests;
    },

    openImage(img) {
      this.modalDialog = true;
      this.modalImage = img;
    },
  },

  created() {
    this.getNotifications();
  },
};
</script>
